// Declare action names as constants with uppercase string

import ApiService from '../services/ApiService';
export const GET_TABLEDATA_BEGIN = 'GET_TABLEDATA_BEGIN';
export const GET_TABLEDATA_SUCCESS = 'GET_TABLEDATA_SUCCESS';
export const GET_TABLEDATA_FAILURE = 'GET_TABLEDATA_FAILURE';
export const CLEAR_COURSES = 'CLEAR_COURSES';

// Thunk: this is a special type of action that can dispatch other actions
export function getFetchTableData() {
    return async dispatch => {
        dispatch(getTableDataBegin());
        await ApiService.getTableData()
            .then(
                result => {
                    dispatch(getTableDataSuccess(result));
                },
                error => {
                    dispatch(getTableDataFailure(error));
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'This is a demo error message' });
                }
            )
    };
}

// Action: Function that returns an object with action data for reducer
export const getTableDataBegin = () => ({
    type: GET_TABLEDATA_BEGIN
});
export const getTableDataSuccess = data => ({
    type: GET_TABLEDATA_SUCCESS,
    payload: { data }
});
export const getTableDataFailure = error => ({
    type: GET_TABLEDATA_FAILURE,
    payload: { error }
});

export const clearCourses = () => ({
    type: CLEAR_COURSES,
});